"use strict";

var _slicedToArray = require("/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/slicedToArray");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.object.entries");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

exports.renderMetaTags = function (data) {
  return data.map(function (_ref) {
    var tag = _ref.tag,
        attributes = _ref.attributes,
        content = _ref.content;
    var key = [tag];

    if (attributes && "property" in attributes) {
      key.push(attributes.property);
    }

    if (attributes && "name" in attributes) {
      key.push(attributes.name);
    }

    var Tag = tag;
    return react_1["default"].createElement(Tag, Object.assign({
      key: key.join("-")
    }, attributes), content);
  });
};

var serializeAttributes = function serializeAttributes(attributes) {
  if (!attributes) {
    return "";
  }

  return " " + Object.entries(attributes).map(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        key = _ref3[0],
        value = _ref3[1];

    return "".concat(key, "=\"").concat(value, "\"");
  }).join(" ");
};

exports.renderMetaTagsToString = function (data) {
  return data.map(function (_ref4) {
    var tag = _ref4.tag,
        attributes = _ref4.attributes,
        content = _ref4.content;

    if (content) {
      return "<".concat(tag).concat(serializeAttributes(attributes), ">").concat(content, "</").concat(tag, ">");
    }

    return "<".concat(tag).concat(serializeAttributes(attributes), " />");
  }).join("\n");
};